import Vue from 'vue';
import VueRouter from 'vue-router';
import 'default-passive-events';
import '@codequality/vue-cli-base';
import '@codequality/vue-cli-base/dist/cqvue.css';
import { HttpStatusCode } from '@codequality/vue-cli-base';
import 'element-ui/lib/theme-chalk/index.css'; // "import @codequality"より下に設定
import '@/filters';

import App from '@/entries/user/App.vue';

import router from '@/entries/user/router';
import { PublicRoutes } from '@/entries/user/router/AppRouteConfig';

import ElwButton from '@/components/elwButton/ElwButton.vue';
import ElwYmPicker from '@/components/elwYmPicker/ElwYmPicker.vue';
import ElwEnumSelect from '@/components/elwEnumSelect/ElwEnumSelect.vue';
import Currency from '@/components/currency/Currency.vue';

Vue.config.productionTip = false;

// グローバルコンポーネント設定
Vue.component('elw-button', ElwButton);
Vue.component('elw-ym-picker', ElwYmPicker);
Vue.component('elw-enum-select', ElwEnumSelect);
Vue.component('currency', Currency);

Vue.directive('click-outside', {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  bind: function (el: any, binding: any, vnode: any) {
    el.clickOutsideEvent = function (event: Event) {
      if (!(el == event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent);
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  unbind: function (el: any) {
    document.body.removeEventListener('click', el.clickOutsideEvent);
  },
});

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');

/**
 * エラー処理
 * watch、ライフサイクルイベントは検知できる
 * 非同期処理内、methodsでのエラーは検知できない
 * 非同期処理をasync/await化すると検知できる
 */
Vue.config.errorHandler = (err) => {
  // router の同一ルート遷移エラーは無視
  if (err.name === 'NavigationDuplicated') return;
  console.error('Captured in Vue.config.errorHandler');
  console.error(err.name);
  console.error(err.message);
  console.error(err.stack);
  errorPage((err as any).response, router); // eslint-disable-line @typescript-eslint/no-explicit-any
};

/**
 * setTimeoutやsetIntervalといったネイティブな非同期処理内でのエラーを検知
 */
window.addEventListener('error', (event) => {
  console.error('Captured in error EventListener', event.error);
  pushErrorRoute(router);
});

/**
 * Promise内のエラーを検知
 */
window.addEventListener('unhandledrejection', (event) => {
  console.error('Captured in unhandledrejection EventListener', event.reason);
  errorPage(event.reason.response, router);
});

/**
 * エラー画面への遷移
 *
 * @param response
 * @param router
 */
const errorPage = (response: Response, router: VueRouter): void => {
  // 認可エラー
  if (response && response.status === HttpStatusCode.unauthorized) {
    router.push(PublicRoutes.Unauthorized);
    return;
  }
  pushErrorRoute(router);
};

/**
 * エラー画面への遷移
 *
 * @param router
 */
const pushErrorRoute = (router: VueRouter): void => {
  router.push(PublicRoutes.Exception);
};
